import NodeContent from '../NodeContent';

function NormalNode(props) {
  return (
    <div className="icp-workflow-node normal-node">
      <NodeContent {...props} />
    </div>
  );
}

export default NormalNode;
